import { api_configs } from "src/api-services";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const viewEmployee = createAsyncThunk(
    'viewempoyee/viewEmployee',
    async (payload) => {
        console.log("payload12", payload)
        try {
            // Simulating async operation, returning dummy data after a delay
            const res = await axios({
                method: "GET",
                // url: `${api_configs.employeeAttendanceList}?userId=${payload}`,
                url: `${api_configs.viewEmployee}?_id=${payload}`,
                headers: {
                    token: window.localStorage.getItem("token")
                }
            });
            if (res.data.responseCode === 200) {
                return res.data.result;
            }
            // await new Promise((resolve) => setTimeout(resolve, 1000)); // Simulating delay
            // return cardDetails.data; // Return dummy data directly
        } catch (error) {
            throw error; // Let the rejection handle in createSlice catch this
        }
    }
);

// Slice for products
const ViewEmployeeSlice = createSlice({
    name: 'viewempoyee',
    initialState: { isLoading: false, employee: [], error: null },
    extraReducers: (builder) => {
        builder
            .addCase(viewEmployee.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(viewEmployee.fulfilled, (state, action) => {
                state.isLoading = false;
                state.employee = action.payload;
                state.error = null;
            })
            .addCase(viewEmployee.rejected, (state, action) => {
                state.isLoading = false;
                state.employee = [];
                state.error = action.error.message; // Access error message
            });
    },
});



// Selectors to access state from Redux store
export const selectEmployee = (state) => state.viewempoyee.employee;

// Exporting reducers
export default ViewEmployeeSlice.reducer;